var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{staticClass:"switch-button",model:{value:(_vm.radioValue),callback:function ($$v) {_vm.radioValue=$$v},expression:"radioValue"}},_vm._l((_vm.options),function(item,index){return _c('el-radio',{key:index,attrs:{"border":"","label":item.value}},[_vm._v(" "+_vm._s(item.label || _vm.$t(item.labelI18nKey))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }